import {
  Card,
  FormSection,
  Box,
  Children,
  LocalizedString,
} from "@dbn/omnichannel-design-system-g4p";

import * as classes from "./EditSection.css";

type Props = {
  children: Children;
  title: LocalizedString;
};

export function EditSection(props: Props) {
  return (
    <Box column grow shrink className={classes.container}>
      <Card>
        <FormSection
          heading={{
            title: props.title,
          }}
        >
          {props.children}
        </FormSection>
      </Card>
    </Box>
  );
}
